var exports = {
  "Z": "xcc377c0b--12d6fe--layout",
  "S": "xcc377c0b--12d6fe--layout--fullwidth",
};

module.exports = exports;
